export default {
  monthNames: {
    short: {
      january: 'JAN',
      february: 'FEV',
      march: 'MAR',
      april: 'ABR',
      may: 'MAI',
      june: 'JUN',
      july: 'JUL',
      august: 'AGO',
      september: 'SET',
      october: 'OUT',
      november: 'NOV',
      december: 'DEZ',
    },
    long: {
      january: 'Janeiro',
      february: 'Fevereiro',
      march: 'Março',
      april: 'Abril',
      may: 'Maio',
      june: 'Junho',
      july: 'Julho',
      august: 'Agosto',
      september: 'Setembro',
      october: 'Outubro',
      november: 'Novembro',
      december: 'Dezembro',
    },
  },
  pageNotFound: {
    warning: 'Página não encontrada :(',
    backToPortal: 'Voltar ao portal',
  },
  login: {
    email: {
      label: 'E-mail de Usuário',
      placeholder: 'Email',
    },
    password: {
      label: 'Senha',
      placeholder: 'Senha',
      forgot: 'Esqueceu a senha?',
      show: 'Exibir Senha',
    },
    recoverPassword: {
      greetings: 'Olá',
      label:
        'Informe seu e-mail cadastrado abaixo. Mandaremos um link para redefinir a sua senha.',
      resetPasswordLabel: 'Configure uma nova senha a baixo',
      errorMessage: 'Email não encontrado ou bloqueado.',
      successMessage:
        'Sucesso! O processo de renovação de senha foi enviado para o seu email.',
      renewMessage: 'Preencha o formulário para renovar sua senha.',
      renewError: 'Erro ao renovar a senha, tente novamente.',
      smallPasswordError: 'Sua senha deve ter no mínimo 8 caracteres',
      wrongPasswordError: 'As senhas digitas não conferem',
      renewSuccess: 'Senha atualizada com sucesso.',
      button: 'REDEFINIR SENHA',
      backToLogin: 'Voltar ao login',
      newPassword: 'Nova senha',
      newPasswordConfirm: 'Confirme nova senha',
    },
    keepMeLogged: {
      label: 'Mantenha-me Logado',
    },
    signInButton: {
      label: 'ENTRAR',
    },
    welcome: 'Bem-vindo!',
    signin: 'Conecte-se na sua conta',
    error: 'Erro ao efetuar o login, verifique os dados informados.',
    errorNotFound: 'Entre em contato com o suporte',
    renew: 'Você renovou e o endereço mudou para um projeto',
  },
  index: {
    content: {
      introduction: 'Introdução',
      showIntroduction: 'MOSTRAR INTRODUÇÃO',
      hideIntroduction: 'ESCONDER INTRODUÇÃO',
      minutes: 'Minutos',
      classes: 'Aulas',
      showClasses: 'EXIBIR AULAS',
      hideClasses: 'ESCONDER AULAS',
      dateOpenModule: 'ESTE MÓDULO SERÁ LIBERADO EM',
      openSubmodule: 'ABRIR SUBMÓDULO',
      closeSubmodule: 'FECHAR SUBMÓDULO',
      completed: 'COMPLETO',
      concluded: 'CONCLUÍDO',
      completedAt: 'CONCLUÍDO EM',
      beginClass: 'INICIAR AULA',
      emptyMessage: 'No momento não há nenhum conteúdo para este módulo!.',
      progressiveUnavailable: 'COMPLETE AS AULAS ANTERIORES',
    },
    header: {
      startCourse: 'INICIAR CURSO',
      resumeCourse: 'CONTINUAR CURSO',
      notes: {
        button: 'MINHAS ANOTAÇÕES',
        modal: {
          title: 'Minhas anotações',
          download: 'BAIXAR NOTAS',
        },
      },
      faq: {
        button: 'PERGUNTAS FREQUENTES',
        modal: {
          title: 'Perguntas frequentes',
        },
      },
      search: {
        title: 'O que você está procurando?',
        popularTags: 'TAGS POPULARES',
        resultCount:
          '{resultCount} resultados encontrados com o filtro "{searchFilter}"',
        seeMore: 'Veja Mais',
      },
      nextClass: {
        title: 'SUA PRÓXIMA AULA',
      },
      emailSupport: 'suporte@ignicaodigital.com.br',
      doubts: 'Tem dúvidas ou problemas? Fale com o nosso suporte:',
    },
    sidebar: {
      completedModules: 'MÓDULOS COMPLETADOS',
    },
  },
  general: {
    labels: {
      loading: 'Carregando...',
      uploading: 'Fazendo Upload',
    },
    actions: {
      search: 'Pesquisar',
      communitySearch: 'Buscar na comunidade',
      clearSearch: 'Limpar busca',
      start: 'COMEÇAR',
      cancel: 'Cancelar',
      orderBy: 'Ordenar por',
      updateChanges: 'SALVAR ALTERAÇÕES',
      access: 'Acessar',
      edit: 'Editar',
      remove: 'Remover',
      save: 'Salvar',
      back: 'Voltar',
      mute: 'Silenciar',
      unmute: 'Tirar {user} do modo silencioso',
      saveChanges: 'Salvar Alterações',
      filter: 'Filtrar',
    },
    messages: {
      noRecordFound: 'Nenhum registro encontrado',
    },
    time: {
      formatFns: 'd/M/YYYY - H:mm',
      format: 'd/m/Y - H:i \\hr\\s',
      min: 'Min',
    },
  },
  logout: {
    label: 'Sair',
  },
  class: {
    details: {
      tags: 'Tags',
      nav: {
        description: 'Descrição',
        comments: 'Comentários',
        extraContent: 'Extra',
        notes: 'Anotações',
      },
      comments: {
        title: 'Comentários',
        reply: 'Responder',
        remove: 'Remover',
        post: 'Postar',
        pending: 'AGUARDANDO MODERAÇÃO',
        highlight: 'Destacar Resposta',
        highlighted: 'Resposta Destacada',
        removeHighlight: 'Remover Destaque',
      },
      downloads: {
        download: 'Baixar',
        visualize: 'Visualizar',
      },
    },
    progress: {
      completeClass: 'COMPLETAR AULA',
      moveToNext: 'E IR PARA A PRÓXIMA',
      moveToPrev: 'VOLTAR PARA AULA ANTERIOR',
      seeIndex: 'VER ÍNDICE DE AULAS',
    },
    sidebar: {
      module: 'Módulo',
      noContent: 'No momento não existe nenhum conteúdo',
    },
  },
  profile: {
    loadingImage: 'Carregando Imagem...',
    imageAlt: 'Imagem de Perfil',
    changeImage: 'Alterar Imagem',
    fileSizeError: 'O tamanho da imagem é superior ao permitido',
    errorLoadingImage: 'Erro ao carregar imagem',
    menuTitle: 'MEU PERFIL E SENHA',
    name: 'Nome',
    password: 'Senha',
    retypePassword: 'Confirmar Senha',
    passwords: {
      alertError: 'Erro atualizando a senha, verifique os dados informados.',
      alertSuccess: 'Senha atualizada com sucesso.',
      notMatching: 'As senhas informadas são divergentes.',
    },
    updatedMessage: 'Perfil atualizado com sucesso',
    updateError: 'Erro atualizando perfil, tente novamente mais tarde',
  },
  cookie: {
    disabled: 'Cookies não habilitados',
    enable:
      'Os cookies do seu navegador não estão ativados, reative e recarregue a página.',
  },
  banner: {
    defaultText: 'Edite o seu banner nas configurações',
    defaultButtonText: 'Ação do botão',
  },
  community: {
    notFound: 'Comunidade não encontrada',
    title: 'Comunidade',
    night_mode: 'Modo noturno',
    discussion: 'Discussão',
    labels: {
      like: 'Curtir',
      liked: 'Curtido',
      likes: 'Curtidas',
      bestComments: 'Melhor resposta',
      updatedAt: 'Atualizado a',
    },
    users: {
      title: 'Usuários',
      members: 'Membros',
      notMuted: 'Não silenciado',
      profile: {
        title: 'Perfil',
        view: 'Ver Perfil',
        header: 'Perfil do Usuário',
        statistics: 'Estatísticas',
        badges: 'Medalhas',
        notifications: 'Notificações por Email',
        createdPosts: 'Posts Criados',
        createdComments: 'Comentários Criados',
        likes: 'Curtidas',
        postsLikes: 'Curtidas de Posts',
        commentsLikes: 'Curtidas de Comentários',
      },
      mailSettings: {
        info: 'Me notifique quando...',
        postComment: 'Alguém comentar no meu post',
        postLike: 'Alguém curtir o meu post',
        followedPostComment: 'Alguém comentar em um post que estou seguindo',
        followedPostLike: 'Alguém curtir um post que estou seguindo',
        commentLike: 'Alguém curtir um comentário que escrevi',
        reply: 'Alguém responder um comentário que escrevi',
        postMention: 'Alguém me mencionar em um post',
        commentMention: 'Alguém me mencionar em um comentário',
        badge: 'Eu receber uma medalha',
        postApproved: 'Meu post for aprovado',
        commentApproved: 'Meu comentário for aprovado',
      },
    },
    list: {
      selectOne: 'Selecione a Comunidade Desejada',
    },
    events: {
      openDate: 'Início',
      closeDate: 'Fim',
    },
    posts: {
      viewPost: 'Visualizar {kind}',
      title: 'Posts',
      searchLabel: 'Buscar membro por nome ou e-mail',
      actions: {
        create: 'Criar Novo Post',
        start: 'Escrever novo post',
        comment: 'No que você está pensando?',
      },
      removed: 'Post removido',
      follow: 'Seguir post',
      unfollow: 'Não seguir post',
      writeTitle: 'Escreva um título',
      createBookmark: 'Adicionar aos favoritos',
      removeBookmark: 'Remover dos favoritos',
      kind: {
        post: 'Post',
        event: 'Evento',
      },
      toTop: 'No Topo',
      toAside: 'Na Lateral',
      pinTitle: 'Fixar',
      pin: {
        top: 'Fixar no Topo',
        aside: 'Fixar na Lateral',
      },
      unpin: {
        top: 'Desafixar do Topo',
        aside: 'Desafixar da Lateral',
      },
      messages: {
        follow: {
          success: 'Post seguido com sucesso!',
          error: 'Não foi possível seguir o post.',
        },
        unfollow: {
          success: 'Post deixado de seguir com sucesso!',
          error: 'Não foi possível deixar de seguir o post.',
        },
        createBookmark: {
          success: 'Post adicionado aos favoritos com sucesso!',
          error: 'Não foi possível adicionar o post aos favoritos.',
        },
        removeBookmark: {
          success: 'Post removido dos favoritos com sucesso!',
          error: 'Não foi possível remover o post dos favoritos.',
        },
        create: {
          error: 'Preencha o título, a tag e o conteúdo',
        },
      },
    },
    badges: {
      title: 'Medalhas',
      assign: 'Dar medalhas',
      select: 'Selecione uma ou mais medalhas',
      selected:
        'Nenhuma medalha selecionada | 1 medalha selecionada | {count} medalhas selecionadas',
      no_badges_registered: 'Não existem medalhas cadastradas',
    },
    comments: {
      loadAll: 'Carregar todos os comentários',
      title: 'Nenhum comentário | 1 comentário | {count} comentários',
      label: 'Comentários',
      actions: {
        create: 'Comentar',
        remove: 'Remover Comentário',
        update: 'Atualizar Comentário',
        comment: 'Escrever um comentário',
      },
      warnings: {
        remove: 'Tem certeza que deseja remover este comentário',
      },
      replies: {
        view: '1 resposta | {count} respostas',
        viewMore: 'Ver mais respostas',
      },
    },
    useTerms: {
      title: 'Termos de Uso',
      accept: 'Aceitar Termos de Uso',
      decline: 'Eu recuso os termos',
      agreed: 'Aceito os termos de uso da comunidade',
      seeTerms: 'Ver termos de uso da comunidade',
    },
    moderation: {
      title: 'Moderação',
      postStatus: 'Status do post',
      status: {
        pending: 'Pendente',
        visible: 'Visível',
        locked: 'Trancado',
        muted: 'Silenciado',
      },
      filters: {
        apply: 'Aplicar',
        locked: 'Trancados',
        pending: 'Pendentes',
        muted: 'Silenciados',
        posts: 'Filtrar posts',
        comments: 'Filtrar comentários',
      },
    },
    tags: {
      popular: 'Tags mais populares',
      add: 'Clique e/ou digite para adicionar tags',
      showAll: 'Mostrar tudo',
      showLess: 'Mostrar menos',
      selectLabel: 'Clique ou pressione enter para adicionar',
      deselectLabel: 'Clique ou pressione enter para remover',
      selectedLabel: 'Adicionada',
      emptyListLabel: 'Não existem tags disponíveis',
      all: 'Todas as tags',
    },
    rules: {
      title: 'Regras',
      sidebarLabel: 'Regras da comunidade',
    },
    orders: {
      resultCount: 'Mostrando {resultCount} de {totalResult} membros',
      apply: 'Aplicar',
      recent: 'Mais recente',
      popular: 'Mais popular',
      label: 'ORDENAR MEMBROS POR',
      posts: 'Mais posts criados',
      postLikes: 'Mais curtidas recebidas em posts',
      comments: 'Mais comentários escritos',
      commentLikes: 'Mais curtidas recebidas em comentários',
      badges: 'Maior quantidade de medalhas',
      bestComments: 'Maior quantidade de boas respostas em comentários',
    },
    notifications: {
      title: 'Notificações',
      timeFrom: '{time} atrás',
      seeAll: 'Ver tudo',
      markAsRead: 'Marcar como lida',
      markAsUnread: 'Marcar como não lida',
      markAllAsRead: 'Marcar todas como lidas',
    },
    bookmark: {
      title: 'Favoritos',
    },
    medias: {
      video: {
        urlPlaceholder: 'URL do Youtube ou Vimeo',
        postTitle: 'Adicionar vídeo ao post',
        commentTitle: 'Adicionar vídeo ao comentário',
        add: 'Adicionar ao post',
      },
    },
  },
  pagination: {
    first: 'Primeira',
    last: 'Última',
    next: 'Próxima',
    previous: 'Anterior',
  },
  emojis: {
    search: 'Pesquisa',
    notfound: 'Nenhum Emoji encontrado',
    categories: {
      search: 'Resultado',
      recent: 'Recentes',
      people: 'Pessoas & Smileys',
      nature: 'Animais & Natureza',
      foods: 'Comida & Bebidas',
      activity: 'Atividade',
      places: 'Viagem & Lugares',
      objects: 'Objetos',
      symbols: 'Símbolos',
      flags: 'Bandeiras',
      custom: 'Personalizado',
    },
  },
  textEditor: {
    toolbar: {
      fontSize: 'Tamanho da Fonte',
      fontType: 'Tipo da Fonte',
      align: 'Alinhar Texto',
      headerType: 'Tipo de Cabeçalho',
      clean: 'Limpar Texto',
      textColor: 'Cor do Texto',
      textBackground: 'Cor de Fundo do Texto',
      bold: 'Negrito',
      italic: 'Itálico',
      underlined: 'Sublinhado',
      strike: 'Riscado',
      unorderedList: 'Lista não Ordenada',
      orderedList: 'Lista Ordenada',
      link: 'Inserir Link',
      image: 'Inserir Imagem',
      subscript: 'Subscript',
      superscript: 'Superscript',
      blockquote: 'Citação',
      increaseIndent: 'Aumentar Indentação',
      decreaseIndent: 'Diminuir Indentação',
    },
    fontSize: {
      small: 'pequena',
      medium: 'média',
      large: 'grande',
      huge: 'gigante',
    },
    font: {
      sansSerif: 'Sans Serif',
      serif: 'Serif',
      monospace: 'Monospace',
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/messages/languages/pt_BR.js